import type React from 'react';
import { createContext, useContext } from 'react';

export type RouteConfig = Record<string, string | ((...args: unknown[]) => string) | undefined>;

const RouteConfigContext = createContext<RouteConfig | null>(null);

export const RouteConfigProvider = ({ config, children }: React.PropsWithChildren<{ config: RouteConfig }>) => {
  return <RouteConfigContext.Provider value={config}>{children}</RouteConfigContext.Provider>;
};

export const useRouteConfig = <T extends RouteConfig = RouteConfig>() => {
  const ctx = useContext(RouteConfigContext);

  if (!ctx) throw new Error('useRouteConfig must be used within a RouteConfigProvider');

  return ctx as T;
};
